/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerSingleUxExposures} from '../api'

 export const useQueryGetCustomerSingleUxExposures = createReactQueryHook('getCustomerSingleUxExposures', getCustomerSingleUxExposures)
